import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';
import './TingeeThirdParty.scss';
import { THIRDPARTY_CODE } from 'constants/app';
import useThirdPartyConfigForm from './hooks/useThirdPartyConfigForm';
import ThirdPartyConfigLayout from './components/ThirdPartyConfigLayout';

const ShopeePayThirdParty = ({ id, setOpenContent, setId }) => {
  const { t: translation } = useTranslation();
  const [form] = useForm();

  const {
    loading,
    isConnected,
    hasFormChanged,
    showConfirmTest,
    setShowConfirmTest,
    handleSubmit,
    handleConfirmAndSave,
    handleValuesChange,
  } = useThirdPartyConfigForm({
    id,
    setId,
    form,
    translation,
    thirdPartyCode: THIRDPARTY_CODE.SHOPEEPAY,
    mapFromPartyRequiredData: (partyRequiredData = {}, res = {}) => ({
      clientId: partyRequiredData?.clientId || '',
      merchantId: partyRequiredData?.merchantId || '',
      storeExtId: partyRequiredData?.storeExtId || '',
      secretKey: partyRequiredData?.secretKey || '',
      isEnable: res?.partyEnableStatus === 1,
    }),
    buildTestPayload: (values = {}) => ({
      clientId: values.clientId,
      merchantId: values.merchantId,
      storeExtId: values.storeExtId,
      secretKey: values.secretKey,
      amount: 10000,
    }),
    buildUpdatePayload: (values = {}, isConnectedLocal) => ({
      data: {
        partyRequiredData: {
          clientId: values.clientId,
          merchantId: values.merchantId,
          storeExtId: values.storeExtId,
          secretKey: values.secretKey,
        },
        partyActiveStatus: isConnectedLocal ? 1 : 0,
        partyEnableStatus: values.isEnable ? 1 : 0,
      },
    }),
    testApi: ThirdPartyIntegration.testConfigsShopeePay,
    updateApi: ThirdPartyIntegration.updateConfigsShopeePay,
  });

  return (
    <ThirdPartyConfigLayout
      loading={loading}
      form={form}
      translation={translation}
      title={`Cài đặt tài khoản ${translation('expand_setting.SHOPEEPAY')}`}
      isConnected={isConnected}
      hasFormChanged={hasFormChanged}
      onBack={() => setOpenContent('')}
      onFinish={handleSubmit}
      onValuesChange={handleValuesChange}
      showConfirmTest={showConfirmTest}
      setShowConfirmTest={setShowConfirmTest}
      onConfirmAndSave={handleConfirmAndSave}
      confirmTitle={translation('vietqr.sendVD')}
      confirmMessage={translation('vietqr.testTransactionMessage')}
    >
      <Form.Item required label='Client ID' name='clientId' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Merchant ID' name='merchantId' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Store Ext ID' name='storeExtId' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Secret Key' name='secretKey' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
    </ThirdPartyConfigLayout>
  );
};

export default ShopeePayThirdParty;
